export const CHROME = 'chrome';
export const FIREFOX = 'firefox';
export const SAFARI = 'safari';
